/* eslint key-spacing: 'off', comma-spacing: 'off' */
import common from '@/scripts/common';
export default {
    getAllMismatchedVariables: function (variables) {
        return getMismatchedVariablesAll(variables);
        // var variables1 = getMismatchedVariables(variables, true);
        // var variables2 = getMismatchedVariables(variables, false);
        // return variables1.concat(variables2);
    }
}

function getMismatchedVariablesAll(variables) {
    addCompressedTitle(variables);
    //console.log('getMismatchedVariablesAll', variables);
    var mismatched = variables.map(v1 =>
        variables.filter(v2 => v1.variable === v2.variable && v1.year < v2.year)
            .map(v2 => getVariableMismatch(v1, v2)))
        .filter(m => m);
    //console.log('getMismatchedVariablesAll', mismatched);
    if (mismatched.length > 0)
        mismatched = mismatched.reduce((a, b) => a.concat(b)).filter(m => m);
    //console.log('getMismatchedVariablesAll', mismatched);
    const flattened = mismatched.map(m => flatten(m));
    const byVariable = common.groupBy(flattened, 'variable');
    var reduced = byVariable.map(g => reduceByMatchingVariables(g, variables));
    var results = [];
    reduced.forEach(r1 =>
        r1.forEach(r2 => results.push(r2)));
    return results;
}

function combineMatchingYears(list, allVariables) {
    var variable1 = allVariables.filter(v => v.variable === list[0].variable && v.year === list[0].year1)[0];
    var variable2 = allVariables.filter(v => v.variable === list[0].variable && v.year === list[0].year2)[0];
    return {
        variable: list[0].variable,
        firstYears: [...new Set(list.map(l => l.year1))].join(', '),
        secondYears: [...new Set(list.map(l => l.year2))].join(', '),
        label1: variable1.variableTitle,
        label2: variable2.variableTitle
    }
}

function reduceByMatchingVariables(variableList, allVariables) {
    variableList.forEach(v => v.combinedLabels = v.label1 + v.label2);
    var byVariable1 = common.groupBy(variableList, 'combinedLabels');
    var results = byVariable1.map(v => combineMatchingYears(v, allVariables));

    //console.log('reduceByMatchingVariables', JSON.stringify(results));
    return results;
}

function flatten(mismatch) {
    return {
        variable: mismatch.variable,
        year1: mismatch.mismatches[0].v1,
        year2: mismatch.mismatches[0].v2,
        label1: mismatch.mismatches[1].v1,
        label2: mismatch.mismatches[1].v2
    }
}



function compress(label) {
    return label.toLowerCase().replace(/[^\w\d]/g, '');
}
function addCompressedTitle(variables) {
    // if (!variables && process.env.NODE_ENV === 'development') 
    //     debugger
    variables.forEach(v => v.variableTitleCompressed = compress(v.variableTitle));
}

var matchColumns = ['groupTitle', 'group', 'variableTitleCompressed', 'isRow', 'isColumn', 'isDependent', 'isIndependent', 'isControl', 'isCategorical'];

function formatMismatch(v1, v2, column) {
    //return column + ': [' + v1[column] + '] !== [' + v2[column] + ']';
    var displayColumn = column === 'variableTitleCompressedx' ? 'variableTitle' : column;
    //console.log('formatMismatch', v1, v2, displayColumn);
    return {
        column: displayColumn,
        v1: v1[displayColumn],
        v2: v2[displayColumn]
    }
}
function getVariableMismatch(v1, v2) {
    // if (v1.year <= v2.year)
    //     return null;
    var misMatches = matchColumns.map(c => v1[c] === v2[c] ? null :
        formatMismatch(v1, v2, c)).filter(r => r !== null);
    if (misMatches.length === 0)
        return null;
    misMatches.unshift(formatMismatch(v1, v2, 'year'));
    //console.log(v1, v2, misMatches);
    //console.log('getVariableMismatch', v1.variable, misMatches);
    return { variable: v1.variable, mismatches: misMatches }
}


function getMismatchedVariables(variables, oldYears) {
    if (oldYears)
        variables = variables.filter(c => c.year < 2011);
    else
        variables = variables.filter(c => c.year > 2010);
    addCompressedTitle(variables);
    var mismatched = variables.map(v1 =>
        variables.filter(v2 => v1.variable === v2.variable && v1.year < v2.year).map(v2 => getVariableMismatch(v1, v2)))
        .filter(m => m);
    if (mismatched.length > 0)
        mismatched = mismatched.reduce((a, b) => a.concat(b)).filter(m => m);
    return mismatched;
}
